import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { axiosInstance } from "../App";
import { Plus, X, Tag } from "lucide-react";
import { toast } from "sonner";

function TaskTags({ taskId, tags, onUpdate }) {
  const [newTag, setNewTag] = useState("");
  const [adding, setAdding] = useState(false);

  const handleAddTag = async (e) => {
    e.preventDefault();
    if (!newTag.trim()) return;

    // Format tag
    let formattedTag = newTag.trim().toLowerCase();
    if (!formattedTag.startsWith("#")) {
      formattedTag = `#${formattedTag}`;
    }

    // Check if already exists
    if (tags.includes(formattedTag)) {
      toast.error("Bu etiket zaten mevcut");
      return;
    }

    setAdding(true);
    try {
      const updatedTags = [...tags, formattedTag];
      await axiosInstance.put(`/tasks/${taskId}`, {
        tags: updatedTags
      });
      setNewTag("");
      toast.success("Etiket eklendi");
      onUpdate();
    } catch (error) {
      toast.error("Etiket eklenemedi");
    } finally {
      setAdding(false);
    }
  };

  const handleRemoveTag = async (tagToRemove) => {
    try {
      const updatedTags = tags.filter(tag => tag !== tagToRemove);
      await axiosInstance.put(`/tasks/${taskId}`, {
        tags: updatedTags
      });
      toast.success("Etiket kaldırıldı");
      onUpdate();
    } catch (error) {
      toast.error("Etiket kaldırılamadı");
    }
  };

  const getTagColor = (tag) => {
    const colors = [
      "bg-blue-100 text-blue-800",
      "bg-green-100 text-green-800",
      "bg-purple-100 text-purple-800",
      "bg-orange-100 text-orange-800",
      "bg-pink-100 text-pink-800",
      "bg-yellow-100 text-yellow-800"
    ];
    const hash = tag.split("").reduce((acc, char) => char.charCodeAt(0) + acc, 0);
    return colors[hash % colors.length];
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Tag className="h-4 w-4" />
        <h4 className="font-semibold">Etiketler</h4>
      </div>

      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => (
          <Badge
            key={tag}
            className={`${getTagColor(tag)} flex items-center gap-1 px-2 py-1`}
            data-testid={`tag-${tag}`}
          >
            {tag}
            <button
              onClick={() => handleRemoveTag(tag)}
              className="ml-1 hover:bg-black/10 rounded-full p-0.5"
            >
              <X className="h-3 w-3" />
            </button>
          </Badge>
        ))}
      </div>

      <form onSubmit={handleAddTag} className="flex gap-2">
        <Input
          value={newTag}
          onChange={(e) => setNewTag(e.target.value)}
          placeholder="#etiket ekle..."
          className="flex-1"
          data-testid="tag-input"
        />
        <Button
          type="submit"
          size="sm"
          variant="outline"
          disabled={adding || !newTag.trim()}
          data-testid="add-tag-button"
        >
          <Plus className="h-4 w-4" />
        </Button>
      </form>
    </div>
  );
}

export default TaskTags;
